import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, ShoppingCart } from 'lucide-react';
export function HeaderSection() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'ForceX Complete',
    path: '/products/forcex-complete'
  }, {
    name: 'ForceX DIY',
    path: '/products/forcex-diy'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Warranty',
    path: '/warranty'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="bg-white shadow-sm sticky top-0 z-50 border-b-4 border-brand-yellow" data-id="element-729">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-730">
        <div className="flex justify-between items-center h-20" data-id="element-731">
          <div className="flex-shrink-0 flex items-center" data-id="element-732">
            <Link to="/" data-id="element-733">
              <img className="h-16 w-auto" src="https://cdn.magicpatterns.com/uploads/vAEpLiGwZwCFYgjmhhMBxx/precision_pro_sprayers_header_cropped.png" alt="Precision Pro Sprayers" data-id="element-734" />
            </Link>
          </div>

          <nav className="hidden md:flex space-x-8 items-center" data-id="element-735">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-bold uppercase tracking-wide hover:text-brand-yellow transition-colors ${isActive(link.path) ? 'text-brand-yellow' : 'text-brand-dark'}`} data-id="element-736">
                {link.name}
              </Link>)}
          </nav>

          <div className="hidden md:flex items-center gap-3" data-id="element-737">
            <button className="p-2 text-brand-dark hover:text-brand-yellow transition-colors relative" data-id="element-738">
              <ShoppingCart className="w-6 h-6" data-id="element-739" />
              <span className="absolute -top-1 -right-1 bg-brand-yellow text-brand-dark text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-740">
                0
              </span>
            </button>
            <button className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-9 px-4 text-sm" data-id="element-741">
              <Phone className="w-4 h-4 mr-2" data-id="element-742" />
              Call Now
            </button>
          </div>

          <div className="md:hidden flex items-center gap-3" data-id="element-743">
            <button className="p-2 text-brand-dark hover:text-brand-yellow transition-colors relative" data-id="element-744">
              <ShoppingCart className="w-6 h-6" data-id="element-745" />
              <span className="absolute -top-1 -right-1 bg-brand-yellow text-brand-dark text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-746">
                0
              </span>
            </button>
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-brand-dark hover:text-brand-yellow focus:outline-none p-2" data-id="element-747">
              {isMenuOpen ? <X className="h-8 w-8" data-id="element-748" /> : <Menu className="h-8 w-8" data-id="element-749" />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-750">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-751">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`block px-3 py-4 rounded-md text-base font-bold uppercase ${isActive(link.path) ? 'bg-brand-light text-brand-yellow' : 'text-brand-dark hover:bg-gray-50 hover:text-brand-yellow'}`} onClick={() => setIsMenuOpen(false)} data-id="element-752">
                {link.name}
              </Link>)}
            <div className="px-3 py-4" data-id="element-753">
              <button className="w-full inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-11 px-6 text-base" data-id="element-754">
                <Phone className="w-4 h-4 mr-2" data-id="element-755" />
                Call Now
              </button>
            </div>
          </div>
        </div>}
    </header>;
}